import axios from "axios";

// Server-side IANA lookup (GeoTimeZone + NodaTime) — see MapPoster Controllers/TimezoneController.cs
const api = axios.create({
  baseURL: "",
});

export const getTimeZoneOffset = (lat, lng, time) => {
  console.log("timestamp:", time);
  return api
    .get(
      `/api/timezone/get-time-zone?lat=${lat}&lng=${lng}&time=${time}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((r) => {
      return r.data;
    })
    .catch((error) => {
      let message = "";
      if (error.response) {
        message = `${error.response.status} ${
          error.response.statusText
        }\n${JSON.stringify(error.response.data)}`;
        // Request made and server responded
        console.log(error.response);
      } else if (error.request) {
        message = "no response";
        console.log(error.request);
      } else {
        message = error.message;
        console.log("Error", error.message);
      }
      throw new Error(message);
    });
};

const apis = {
  getTimeZoneOffset,
};

export default apis;
